export const calculateBrutto = (price: number, vat: number): string => {
    if (vat) {
        return (price * (vat + 1)).toFixed(2);
    }
    return price.toFixed(2);
}